// The "Reminder result" (Day13FollowUp): what each contract of the branch reminder e-mails came to on its last day
// (day 14), and its final result once the block has expired. No page imports, so it is tested alone.

// result -> [label, StatusBadge tone]; the same labels as the engine's follow-up e-mail (api/collections_email.RESULT)
export const RESULT = {
    not_charged: ['Not charged', 'danger'],
    partly: ['Partly charged', 'warning'],
    cleared: ['Cleared on Ejar without a payment', 'accent'],
    charged: ['Charged', 'success'],
    unread: ['Ejar not read', 'neutral'],
};
// after the last day (the block has expired): what the page says instead
const FINAL = {
    not_charged: ['Not charged - block expired', 'danger'],
    partly: ['Partly charged - block expired', 'warning'],
    cleared: ['Cleared on Ejar without a payment', 'accent'],
    charged: ['Charged after the follow-up', 'success'],
};

/** The row as the page shows it: the final result once there is one, else the day-14 result. */
export const shown = (r) => {
    const f = r.final;
    if (f && FINAL[f.result]) {
        // not read on day 14: a payment may be older than the follow-up, so plain "Charged"
        const [label, tone] = f.result === 'charged' && r.result === 'unread' ? RESULT.charged : FINAL[f.result];
        return { result: f.result, label, tone, paid: f.paid, payments: f.payments || [], stillOwed: f.stillOwed, notes: r.finalNotes || [], final: true };
    }
    const [label, tone] = RESULT[r.result] || [r.result, 'neutral'];
    return { result: r.result, label, tone, paid: r.paid, payments: r.payments || [], stillOwed: r.stillOwed, notes: r.notes || [], final: false };
};

/** "2026-10-23 14:05:00" -> "23/10 14:05". */
export const when = (at) => {
    const m = String(at || '').match(/^\d{4}-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/);
    return m ? `${m[2]}/${m[1]} ${m[3]}:${m[4]}` : String(at || '');
};
/** Ejar's own system user ("System/النظام") as "System". */
export const who = (by) => (/^system/i.test(String(by || '').trim()) ? 'System' : String(by || '').trim());
/** "2026-10-22" -> "22/10". */
export const day = (d) => { const m = String(d || '').match(/^\d{4}-(\d{2})-(\d{2})/); return m ? `${m[2]}/${m[1]}` : String(d || ''); };

export const NO_FILTERS = { branch: 'all', result: 'all', q: '' };
export const RESULT_FILTERS = [['all', 'All results'], ['not_charged', 'Not charged'], ['partly', 'Partly charged'],
    ['cleared', 'Cleared without a payment'], ['charged', 'Charged']];

export const matches = (r, f = NO_FILTERS) => {
    if (f.branch !== 'all' && r.branch !== f.branch) return false;
    if (f.result !== 'all' && shown(r).result !== f.result) return false;
    const q = String(f.q || '').trim().toLowerCase();
    if (q && ![r.contract, r.customer, r.plate].some((v) => String(v || '').toLowerCase().includes(q))) return false;
    return true;
};

/** The tiles: contracts, asked, charged, still to charge, and how many of each result. */
export const summary = (rows) => {
    const s = { contracts: rows.length, asked: 0, paid: 0, still: 0, not_charged: 0, partly: 0, cleared: 0, charged: 0 };
    rows.forEach((r) => {
        const v = shown(r);
        s.asked += Number(r.toCollect) || 0;
        s.paid += Number(v.paid) || 0;
        s.still += Number(v.stillOwed) || 0;
        if (s[v.result] !== undefined) s[v.result] += 1;
    });
    ['asked', 'paid', 'still'].forEach((k) => { s[k] = Math.round(s[k] * 100) / 100; });
    return s;
};
